import { api } from "@/api";

interface UpdateZeroUserBalancePayload {
  userIds: number[];
}

export async function updateZeroUserBalance(
  payload: UpdateZeroUserBalancePayload
): Promise<{ success: boolean }> {
  const res = await api.client.post("/sub-dealers-new/zero-balances", {
    subDealerIds: payload.userIds,
  });
  return res.data;
}
